import request from '@/router/axios';
// 平台利率
export const platfromRateList = (platformId) => {
  return request({
    url: '/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/platfromRateList',
    method: 'get',
    params: { platformId }
  }).then(res=>{
    return res;
  })
}

// 平台还款方式
export const platformNameAndRateList = (data) => {
  return request({
    url: "/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/platformNameAndRateList",
    method: "post",
    data: data
  });
};

// 平台名称查利率
export const platfromNameRateList = (platformId) => {
  return request({
    url: '/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/platfromNameRateList',
    method: 'get',
    params: { platformId }
  }).then(res=>{
    return res;
  })
}

// 平台产品管理列表
export const loanPlatformTypeManagementPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

//  新增平台类型
export const submitPlatformType = (data) => {
  return request({
    url: `/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/submit_platform_type`,
    method: "post",
    data: data
  });
};

//  删除
export const loanPlatformTypeManagementRemove = (ids) => {
  return request({
    url: `/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/remove`,
    method: "post",
    data: ids
  });
};

//  修改
export const update = (data) => {
  return request({
    url: `/api/blade-loanPlatformTypeManagement/loanPlatformTypeManagement/update`,
    method: "post",
    data: data
  });
};
